import http from '@/request/index'
import betterwe from '@/common/app-common.js'
export default {
  namespaced: true,
  state: {
    activityInfo: null,
    activityData: null,
    //教练排行数据
    coachRankData: {
      curStoreData: null, //当前选择的门店信息
      coachRankList: null
    },
    ugcList: [], //ugc动态列表
    curUgcPage: 1, //当前ugc页数
    showSendFlowerToast: false,
    storeRankData: {
      storeData: [
        {
          name: '长沙',
          code: '4301',
          loaded: false,
          list: []
        },
        {
          name: '南京',
          code: '3201',
          loaded: false,
          list: []
        },
        {
          name: '苏州',
          code: '3205',
          loaded: false,
          list: []
        }
      ]
    },
    //送小红花界面相关
    sendFlowerPage: {
      showToast: false,
      myCoachList: [],
      showDraw: false,
      drawCoachData: null,
      drawResultData: null
    },
    //我的奖品界面相关
    myPrizePage: {
      showToast: false,
      prizeList: null
    },
    //任务界面相关
    taskPage: {
      showToast: false,
      taskList: null
    },
    recordPage: {
      showToast: false,
      recordList: null
    },
    lotteryPage: {
      showToast: false,
      lotteryData: null
    },
    lotteryAnimate: {
      showToast: false,
      coachInfo: null
    }
  },
  getters: {},
  actions: {
    //获取用户身份信息
    initActivity(context) {
      return new Promise(async (resolve, reject) => {
        let params = {
          is_disclosure: betterwe.isApp() ? 0 : 1 //是否公开
        }
        let res = await http
          .getAppWithAppInfo('api/v1/AnnualCoach/initActivity', params)
          .catch(() => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          context.commit('setActivityInfo', res.data.data)
          resolve(true)
        } else {
          context.commit('setActivityInfo', {
            activity_crowd: 5,
            activity_state: 1
          })
          resolve(false)
        }
      })
    },
    actionActivityIndex(context) {
      let params = {
        is_disclosure: betterwe.isApp() ? 0 : 1
      }
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getAppWithAppInfo('api/v1/AnnualCoach/activityIndex', params)
          .catch(() => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          context.commit('setActivityData', res.data.data)
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //获取送花记录
    actionRecordList(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/activityIndex', { t: 1 })
          .catch(() => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          context.commit('setRecordList', res.data.data)
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //非会员抽奖
    actionNoMemberLottery(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/notMemberRaffle')
          .catch(() => {
            resolve(false)
          })

        if (res && res.data && res.data.code == 200) {
          // context.commit('setActivityData', res.data.data);
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //会员赠送小红花
    actionGiveFlower(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/giveRedFlower')
          .catch(() => {
            resolve(false)
          })

        if (res && res.data && res.data.code == 200) {
          // context.commit('setActivityData', res.data.data);
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //获取教练排行数据
    actionCoachRank(context, storeId) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/coachRank', { store_id: storeId })
          .catch(() => {
            reject()
          })
        if (res && res.data.code == 200) {
          let list = []
          for (let i = 0; i < 30; i++) {
            let id = i + 1
            list.push({
              coach_id: id,
              coach_image:
                'https://btw-common-data.betterwestar.com/btw-admin/resource/70aab7b96f3346fa6c548664198e7ad4_wh=2000_2000.jpg',
              is_head_coach: 0,
              coach_name: '张三' + id,
              vote_num: id,
              gift_num: 0,
              is_follow: 0,
              is_me: 0
            })
          }
          list[0].is_head_coach = 1
          list[2].gift_num = 3
          list[3].gift_num = 1
          list[0].is_follow = 1
          list[3].is_follow = 1
          console.log('获取教练排行数据成果')
          context.commit('setCoachRankList', res.data.data)
        }
        resolve()
      })
    },
    //获取门店排行榜
    actionStoreRank(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/storeRank', { city_code: 4301 })
          .catch(() => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          // context.commit('setActivityData', res.data.data);
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //获取所有门店
    actionAllStore(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/getAllStore', { city_code: 4301 })
          .catch(() => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          // context.commit('setActivityData', res.data.data);
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //获取我的奖品
    actionPrizeList(context) {
      return new Promise(async (resolve, reject) => {
        let res = await http
          .getApp('api/v1/AnnualCoach/getRewardList')
          .catch((e) => {
            resolve(false)
          })
        if (res && res.data && res.data.code == 200) {
          context.commit('setMyPrizeList', res.data.data)
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    //获取教练排行数据
    actionUgcData(context) {
      return new Promise(async (resolve, reject) => {
        let params = {
          page: context.curUgcPage
        }
        let res = await http
          .getBaseApp('member/AppCamp/userCenter', params)
          .catch(() => {
            reject()
          })
        if (res && res.data.code == 200) {
          let list = []
          for (let i = 0; i < 30; i++) {
            let id = i + 1
            list.push({
              id: id,
              avatar:
                'https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg',
              isMainCoach: 0,
              truename: '张三' + id,
              flowerNum: id,
              sendNum: 0,
              isFollow: 0
            })
          }
          console.log('获取ugc数据')
          context.commit('setCoachRankList', list)
        }
      })
    },
    //刷新ugc动态
    actionRefreshUgcData(context) {
      context.commit('setUgcPage', 1)
      return dispatch('getUgcData', 1).then(() => {})
    },
    //获取我的奖品列表数据
    actionMyPrize(context) {
      return new Promise(async (resolve, reject) => {
        let params = {
          ttt: 3
        }
        let res = await http
          .getBaseApp('member/AppCamp/userCenter', params)
          .catch(() => {
            reject()
          })
        if (res && res.data.code == 200) {
          let list = []
          for (let i = 0; i < 30; i++) {
            let id = i + 1
            list.push({
              id: id,
              avatar:
                'https://btw-common-data-oss.betterwestar.com/userProfile/8c7d0258485df3b72d7ce25b9d339509_wh=1920_1920.jpg',
              isMainCoach: 0,
              truename: '张三' + id,
              flowerNum: id,
              sendNum: 0,
              isFollow: 0
            })
          }
          console.log('获取我的奖品列表数据')
          context.commit('setMyPrizeList', list)
        }
        resolve()
      })
    },
    //通过用户门店id刷新门店榜
    actionUpdateStoreRankByStoreId(context, storeId) {
      context.state.storeRankData.storeData.map((item) => {
        console.log(item)
        if (Array.isArray(item.list)) {
          item.list.map((item1) => {
            if (item1.store_id == storeId) {
              context.dispatch('actionStoreRank', item.code)
            }
          })
        }
      })
    },
    actionStoreRank(context, cityCode) {
      return new Promise(async (resolve, reject) => {
        let params = {
          city_code: cityCode
        }
        let res = await http
          .getApp('api/v1/AnnualCoach/storeRank', params)
          .catch(() => {
            resolve(false)
          })
        if (res && res.data.code == 200) {
          context.commit('setStoreRankData', {
            cityCode: cityCode,
            data: res.data.data
          })
          resolve(true)
        } else {
          resolve(false)
        }
      })
    }
  },
  mutations: {
    setActivityInfo(state, b) {
      state.activityInfo = b
    },
    setActivityData(state, b) {
      state.activityData = b
    },
    setUgcPage(state, b) {
      state.curUgcPage = b
    },
    //向ugc列表中添加数据
    addUgcList(state, b) {
      state.ugcList = state.ugcList.concact(b)
    },
    setUgcList(state, b) {
      state.ugcList = b
    },
    setCurStoreData(state, b) {
      state.coachRankData.curStoreData = b
    },
    setCoachRankList(state, b) {
      state.coachRankData.coachRankList = b
    },
    setShowSendFlowerToast(state, b) {
      state.sendFlowerPage.showToast = b
    },
    setMyPrizeToast(state, b) {
      state.myPrizePage.showToast = b
    },
    setMyPrizeList(state, b) {
      state.myPrizePage.prizeList = b
    },
    setTaskToast(state, b) {
      state.taskPage.showToast = b
    },
    setTaskList(state, b) {
      state.taskPage.taskList = b
    },
    setRecordToast(state, b) {
      state.recordPage.showToast = b
    },
    setRecordList(state, b) {
      state.recordPage.recordList = b
    },
    setLotteryToast(state, b) {
      state.lotteryPage.showToast = b
    },
    setLotteryAnimateToast(state, b) {
      state.lotteryAnimate.showToast = b
    },
    setCoachFocusByUid(state, b) {
      state.coachRankData.coachRankList.map((item) => {
        if (item.coach_id == b) {
          item.is_follow = 1
        }
      })
    },
    setLotteryData(state, b) {
      state.lotteryPage.lotteryData = b
    },
    setLotteryAnimateCoachInfo(state, b) {
      state.lotteryAnimate.coachInfo = b
    },
    setStoreRankData(state, b) {
      if (b) {
        state.storeRankData.storeData.map((item) => {
          if (b.cityCode == item.code) {
            item.loaded = true
            item.list = b.data
          }
        })
      }
    }
  }
}
